import { IStepDto, StepDto } from 'src/generated_client';

export interface IExtendedStepDto extends IStepDto {
    isNew: boolean;
    isEdited: boolean;
}

export class ExtendedStepDto extends StepDto implements IExtendedStepDto {
    public isNew: boolean;
    public isEdited: boolean;
    public isRemoved: boolean;

    constructor(data?: IExtendedStepDto) {
        super(data);
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property)) {
                    this[property] = data[property];
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/chevrons/steps/ExtendedStepDto.ts